<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { getInboxIconByType } from 'dashboard/helper/inbox';

import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  inboxId: { type: Number, required: true },
  conversationId: { type: Number, required: true },
});

defineEmits(['open']);

const { t } = useI18n();

const inboxGetter = useMapGetter('inboxes/getInbox');

const inbox = computed(() => inboxGetter.value(props.inboxId));
const icon = computed(() =>
  getInboxIconByType(inbox.value.channel_type, inbox.value.medium)
);
const name = computed(
  () => inbox.value.name || t('CONVERSATION_HISTORY.UNKNOWN_INBOX')
);
</script>

<template>
  <button
    v-tooltip.top="t('CONVERSATION_HISTORY.OPEN_CONVERSATION')"
    class="flex items-center gap-2 px-3 py-1 transition-shadow duration-200 border rounded-full shadow-sm bg-n-solid-2/90 backdrop-blur-lg border-n-weak/50 text-n-slate-11 hover:text-n-slate-12 hover:shadow"
    @click="$emit('open', conversationId)"
  >
    <Icon :icon="icon" class="size-3.5" />
    <span class="text-xs font-medium">{{ name }}</span>
    <span class="text-xs text-n-slate-10">{{ `#${conversationId}` }}</span>
    <span class="text-xs i-lucide-arrow-up-right" />
  </button>
</template>
